export const ADDRESS_ABBREVIATIONS: Record<string, string[]> = {
  allée: ['all', 'allee'],
  avenue: ['av', 'ave'],
  boulevard: ['bd', 'boul'],
  'centre commercial': ['ccal', 'cc', 'ccr'],
  chaussée: ['chau', 'chauss'],
  chemin: ['chem', 'ch'],
  cité: ['cite'],
  cours: ['crs'],
  domaine: ['dom'],
  esplanade: ['esp'],
  faubourg: ['fbg', 'fg'],
  galerie: ['gal'],
  hameau: ['ham'],
  impasse: ['imp'],
  lotissement: ['lot'],
  passage: ['pass'],
  place: ['pl', 'plc'],
  promenade: ['prom'],
  quai: ['quai'],
  quartier: ['quar'],
  'rond-point': ['rdpt'],
  route: ['rte', 'rt'],
  'route départementale': ['rd'],
  'route nationale': ['rn'],
  ruelle: ['rle'],
  sentier: ['sent'],
  square: ['sq'],
  traverse: ['trav'],
  voie: ['voie'],
  'zone artisanale': ['za'],
  'zone industrielle': ['zi'],

  saint: ['st'],
  sainte: ['ste'],
  saints: ['sts'],
  saintes: ['stes'],

  premier: ['1er'],
  premiere: ['1ere'],
  deuxième: ['2e', '2ème'],
  troisième: ['3e', '3ème'],

  bâtiment: ['bat'],
  appartement: ['app', 'appt'],
  parking: ['pkg', 'pk'],
}
